/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportCompressorsContent from "./ImportCompressorsContent";

export default class extends Component {
  static propTypes = ImportCompressorsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Para importar sus compresores, los datos deben guardarse en formato ODS o TSV 
          y seguir la siguiente estructura:
        </p>

        <ul>
          <li>Nº de cliente</li>
          <li>Nº de centro</li>
          <li>Nº instalación</li>
          <li>Marcador</li>
          <li>Número de identificación <i>(opcional)</i></li>
          <li>Nº de serie <i>(opcional)</i></li>
          <li>Tipo</li>
          <li>Clasificación</li>
          <li>Marca <i>(opcional)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Después de la integración, un resumen le informará sobre la cantidad 
          de entidades creadas o actualizadas. También estará disponible un 
          archivo de anomalías que contendrá las filas no integradas y los motivos 
          del rechazo.
        </p>

        <p>Las posibles razones de anomalía incluyen:</p>

        <ul>
          <li>Falta de datos obligatorios</li>
          <li>Tipo inexistente</li>
          <li>Clasificación inexistente</li>
          <li>Marca inexistente</li>
        </ul>
      </div>
    );
  }
}
